import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { topicGroups } from '@/mocks/homeData';

function heatClass(heat: number) {
  if (heat >= 80) {
    return 'text-[15px] px-5 py-2.5 font-medium text-foreground-900';
  }
  if (heat >= 60) {
    return 'text-sm px-4 py-2 text-foreground-800';
  }
  return 'text-[13px] px-3.5 py-1.5 text-foreground-700';
}

export default function TopicWall() {
  const [groupKey, setGroupKey] = useState(topicGroups[0].key);
  const [activeTag, setActiveTag] = useState(topicGroups[0].tags[0].label);

  const group = topicGroups.find((item) => item.key === groupKey) ?? topicGroups[0];
  const selected = group.tags.find((item) => item.label === activeTag) ?? group.tags[0];

  return (
    <section id="topics" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="分区 01 · 话题墙"
          title="大家在聊什么：从话题标签进入避雷讨论"
          desc="每个标签都对应一类被反复提到的争议角度。先选分区，再点开你关心的标签，看看这一类话题下集中了哪些说法。"
          actionLabel="查看全部话题"
          actionHref="#unfollow"
        />

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <div className="inline-flex items-center gap-1 rounded-full border border-foreground-200 bg-background-50 p-1">
            {topicGroups.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => {
                  setGroupKey(item.key);
                  setActiveTag(item.tags[0].label);
                }}
                className={
                  item.key === groupKey
                    ? 'whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 font-label text-sm text-background-50'
                    : 'whitespace-nowrap rounded-full px-4 py-2 font-label text-sm text-foreground-700 transition-colors duration-200 hover:bg-background-200'
                }
              >
                {item.label}
              </button>
            ))}
          </div>
          <span className="font-label text-[12px] text-foreground-500">
            字号越大代表近期讨论越集中
          </span>
        </div>

        <div className="mt-7 flex flex-wrap items-center gap-2.5 md:gap-3">
          {group.tags.map((tag) => {
            const isActive = tag.label === activeTag;
            return (
              <button
                key={tag.label}
                type="button"
                onClick={() => setActiveTag(tag.label)}
                className={`${heatClass(tag.heat)} rounded-full border transition-colors duration-200 ${
                  isActive
                    ? 'border-primary-500 bg-primary-500 text-background-50'
                    : 'border-foreground-200 bg-background-50 hover:border-secondary-400 hover:bg-secondary-50'
                }`}
              >
                #{tag.label}
                <span
                  className={
                    isActive
                      ? 'ml-2 font-label text-[11px] text-background-100/85'
                      : 'ml-2 font-label text-[11px] text-foreground-500'
                  }
                >
                  {tag.count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 rounded-lg border border-foreground-200/80 bg-background-50 p-5 md:grid-cols-[1.4fr_1fr] md:p-6">
          <div>
            <span className="font-label text-[11px] tracking-[0.28em] text-primary-600">
              当前选中标签
            </span>
            <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950">
              #{selected.label}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              该标签下共聚合 {selected.count} 条讨论与档案记录，热度指数 {selected.heat}
              。这些说法全部来自公开讨论，仅作为提醒与参考，不代表最终结论。
            </p>
          </div>
          <div className="flex flex-col justify-between gap-4 rounded-md bg-secondary-50 p-4">
            <div>
              <span className="font-label text-[12px] text-secondary-800">热度指数</span>
              <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-secondary-200">
                <div
                  className="h-full rounded-full bg-secondary-500"
                  style={{ width: `${selected.heat}%` }}
                />
              </div>
            </div>
            <a
              href="#unfollow"
              className="inline-flex items-center gap-2 whitespace-nowrap font-label text-sm text-secondary-800 transition-colors duration-200 hover:text-secondary-900"
            >
              查看该话题下的讨论
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}